import BaseConfig from '@/config/base.js'

// mock本地调试
let useMock = false
let mockName = 'nivoa'
let mockLang = 'en'
const mockStrategies = {
  echo() { return mockName === 'echo' },
  joychat() { return mockName === 'joychat' },
  joyu() { return mockName === 'joyu' },
  kiko() { return mockName === 'kiko' },
  vava() { return mockName === 'vava' },
  vibeo() { return mockName === 'vibeo' },
  whonow() { return mockName === 'whonow' },
  nivoa() { return mockName === 'nivoa' }
}

// 确保VUE_APP_CODE_STATE一定有值再用mock
// prettier-ignore
if (process.env.VUE_APP_CODE_STATE) {
  useMock = process.env.VUE_APP_CODE_STATE !== 'product' && process.env.VUE_APP_CODE_STATE !== 'test'
  mockName = process.env.VUE_APP_CODE_STATE !== 'product' ? mockName : 'vava'
  mockLang = process.env.VUE_APP_CODE_STATE !== 'product' ? mockLang : 'en'
}
// 未知环境
else {
  useMock = false
  mockName = 'vava',
  mockLang = 'en'
}

// 正式环境mockFlag一定得是false
export const mockFlag = useMock
export const mockApp = mockName
export const mockLangType = mockLang

// 区分包-包名
export function appNameFlag(type, val) {
  if (useMock) {
    return mockStrategies[type] ? mockStrategies[type]() : false
  }

  const packages = BaseConfig.apps[type]?.packages
  return packages ? packages.includes(val) : false
}

/** 测试页共用 vava 的 host 时，从 ?pkg= 或路径段读出短名 */
function readTestPackageMark() {
  if (typeof window === 'undefined') return ''
  const fromSearch = new URLSearchParams(window.location.search || '').get('pkg') || ''
  if (BaseConfig.validAppPackage.includes(fromSearch)) return fromSearch

  const hash = window.location.hash || ''
  const queryIndex = hash.indexOf('?')
  if (queryIndex >= 0) {
    const fromHash = new URLSearchParams(hash.slice(queryIndex + 1)).get('pkg') || ''
    if (BaseConfig.validAppPackage.includes(fromHash)) return fromHash
  }

  const segments = (window.location.pathname || '').split('/').filter(Boolean)
  for (let i = 0; i < segments.length; i++) {
    if (BaseConfig.validAppPackage.includes(segments[i])) return segments[i]
  }
  return ''
}

// 区分包-域名。测试共用 host 时，有 pkg/路径标记才命中对应包，否则只命中 vava
export function domainNameFlag(type, val) {
  if (useMock) {
    return mockStrategies[type] ? mockStrategies[type]() : false
  }

  const hosts = BaseConfig.apps[type]?.hosts
  if (!hosts || !hosts.includes(val)) return false

  const sharedTestHost = (BaseConfig.apps.vava?.hosts || []).slice(-1)[0]
  if (!BaseConfig.isRelease && val === sharedTestHost) {
    const mark = readTestPackageMark()
    if (mark) return mark === type
    return type === 'vava'
  }
  return true
}

/** 先认包名，没有包名再认域名。避免测试共用 host 把后面的包截走 */
export function resolvePackageShortName(appPackageName, hostname) {
  const list = BaseConfig.validAppPackage
  for (let i = 0; i < list.length; i++) {
    if (appNameFlag(list[i], appPackageName)) return list[i]
  }
  for (let i = 0; i < list.length; i++) {
    if (domainNameFlag(list[i], hostname)) return list[i]
  }
  return ''
}
